export function BasketIcon(): JSX.Element {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.625 7.48977H16.835L12.455 0.929766C12.265 0.649766 11.945 0.509766 11.625 0.509766C11.305 0.509766 10.985 0.649766 10.795 0.939766L6.415 7.48977H1.625C1.075 7.48977 0.625 7.93977 0.625 8.48977C0.625 8.57977 0.635 8.66977 0.665 8.75977L3.205 18.0298C3.435 18.8698 4.205 19.4898 5.125 19.4898H18.125C19.045 19.4898 19.815 18.8698 20.055 18.0298L22.595 8.75977L22.625 8.48977C22.625 7.93977 22.175 7.48977 21.625 7.48977ZM11.625 3.28977L14.425 7.48977H8.825L11.625 3.28977ZM18.125 17.4898L5.135 17.4998L2.935 9.48977H20.325L18.125 17.4898ZM11.625 11.4898C10.525 11.4898 9.625 12.3898 9.625 13.4898C9.625 14.5898 10.525 15.4898 11.625 15.4898C12.725 15.4898 13.625 14.5898 13.625 13.4898C13.625 12.3898 12.725 11.4898 11.625 11.4898Z" />
    </svg>
  );
}
